import React, { useState, createContext, useContext } from "react";
import { removeUserData } from "api/refreshToken";
import { errorMsg, successMsg } from "utils/msg";
import { getRequest, postRequest } from "api";
import { dict, ln, ba, auth, pa } from "api/endpoints";

const AppContext = createContext();

export const AppStore = (props) => {
  const [userData, setUserData] = useState(null);
  const [darkMode, setDarkMode] = useState(JSON.parse(localStorage.getItem("darkMode")) || false);
  const [collapsed, setCollapsed] = useState(JSON.parse(localStorage.getItem("collapsed")) || false);
  const [statusCode, setStatusCode] = useState(200);
  const [txnDate, setTxnDate] = useState("");
  const [menus, setMenus] = useState([]);
  const [paDicts, setPaDicts] = useState([]);

  const toggleCollapsed = (val) => {
    setCollapsed(val);
    localStorage.setItem("collapsed", val);
  };

  const logout = async () => {
    removeUserData();
    setUserData(null);
    setMenus([]);
    setTxnDate("");
    successMsg("Системээс гарлаа.");
  };

  function getPaDicts() {
    postRequest(pa.dicts, {
      Offset: 0,
      Limit: 100,
    }).then((res) => {
      res?.data?.Data?.forEach((e) =>
        setPaDicts((prev) => [
          ...prev,
          {
            name: e.TblName,
            val: e.Val,
            txt: e.Name,
            type: e.Type,
          },
        ])
      );
    });
  }

  const getMenu = () => {
    getRequest(auth.menu).then((res) => {
      setMenus(res.data.Data);
      localStorage.setItem("menu", JSON.stringify(res.data.Data));
    });
  };

  const getTxnDate = () => {
    postRequest(pa.confs, {
      Offset: 0,
      Limit: 50,
    }).then((res) => {
      res?.data?.Data?.forEach((e) => {
        if (e.CnfKey === "TxnDate") {
          setTxnDate(e.CnfVal);
        }
      });
    });
  };

  const getUserData = async () => {
    try {
      const res = await getRequest(auth.profile);
      setUserData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <AppContext.Provider
      value={{
        collapsed,
        toggleCollapsed,
        statusCode,
        setStatusCode,
        logout,
        darkMode,
        setDarkMode,
        userData,
        getUserData,
        txnDate,
        getTxnDate,
        menus,
        getMenu,
        paDicts,
        getPaDicts,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export const App = () => useContext(AppContext);
